import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PlayerColumn } from "../../utils/playerColumns";
import CheckBox from "../CheckBox/CheckBox";

interface PlayersSettingsProps {
  columns: PlayerColumn[];
  onConfirm: (nextColumns: PlayerColumn[]) => void;
  onClose: () => void;
}

export default function PlayerSettings({
  columns,
  onConfirm,
  onClose,
}: PlayersSettingsProps) {
  const { t } = useTranslation();
  const [draftColumns] = useState<PlayerColumn[]>(() =>
    columns.map((column) => ({ ...column }))
  );

  const handleConfirm = () => {
    onConfirm(draftColumns.map((column) => ({ ...column })));
    onClose();
  };

  return (
    <div className="absolute z-10 top-0 left-0 right-0 bottom-0 backdrop-blur-sm rounded-[10px]">
      <div className="float-right w-[95%] lg:w-[80%] bg-[#6886BD] dark:bg-[#B4EB54] rounded-b-[10px] px-[20px] py-[20px]">
        <ul className="flex flex-wrap items-start gap-x-[20px] gap-y-[6px] max-h-[240px] overflow-y-auto pr-[8px]">
          {draftColumns.map((item) => (
            <CheckBox
              teams
              key={item.id}
              isRow
              keys={item.label}
              displayText={item.label}
              titleText={t(item.fullLabel) || item.fullLabel}
              isChecked={item.isShow}
              item={item}
            />
          ))}
        </ul>
        <div className="flex justify-end mt-[10px]">
          <button onClick={handleConfirm} className="bg-white px-[25px] mr-[5px]">
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
